module.exports = __webpack_public_path__ + "img/04.3517215a.png";